/* eslint-disable id-length */
import { convert, LocalDate, ZoneId } from '@js-joda/core';

import { VisitView } from '@dreryk/egabinet-dashboard-frontend-api';

import { ChartData } from '@dreryk/react-charts';
import { TranslateFunction } from '@dreryk/react-common';

import { CHART_CHUNK_SIZE, CHART_COLORS, CHART_ELEMENTS, CHART_LEGEND_LABELS } from '../shared/Chart.utils';

const fillMissingDates = (visits: VisitView[]): VisitView[] => {
   const today = LocalDate.now();
   const dateMap = new Map<string, VisitView>();

   visits.forEach((visit) => {
      const dateStr = visit.visitDate.toString();
      dateMap.set(dateStr, visit);
   });

   const filledVisits: VisitView[] = [];
   for (let i = 0; i < CHART_ELEMENTS; i++) {
      const currentDate = today.minusDays(i);
      const dateStr = currentDate.toString();

      if (dateMap.has(dateStr)) {
         filledVisits.push(dateMap.get(dateStr)!);
      } else {
         filledVisits.push({
            visitDate: currentDate,
            finishedApprovedCount: 0,
         } as VisitView);
      }
   }

   return filledVisits.reverse();
};

export const mapVisitsToChartData = (visits: VisitView[], translate: TranslateFunction): ChartData => {
   const chartData: ChartData = [];
   const visitsPart = visits.splice(-CHART_ELEMENTS);
   const filledVisits = fillMissingDates(visitsPart);

   for (let i = 0; i < CHART_ELEMENTS; i += CHART_CHUNK_SIZE) {
      const chunk = filledVisits.slice(i, i + CHART_CHUNK_SIZE);
      chartData.push({
         color: CHART_COLORS[(i / CHART_CHUNK_SIZE) % CHART_COLORS.length],
         id: `week-${i / CHART_CHUNK_SIZE + 1}`,
         name: translate(CHART_LEGEND_LABELS[i / CHART_CHUNK_SIZE]),
         values: chunk.map((visit) => ({
            x: new Date(convert(visit.visitDate.atTime(0, 0).minusHours(1), ZoneId.UTC).toDate()),
            y: visit.finishedApprovedCount,
         })),
      });
   }
   return chartData;
};
